module.exports = __webpack_public_path__ + "img/template-tutorial-customize-playlist.a251bc19.png";